import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../../baseQuery";

export const ScholarshipsApiSlice = createApi({
    reducerPath: "ScholarshipsApiSlice",
    baseQuery,

    tagTypes: ["scholarships", "userscholarshipsingle", "getfilterWithScholarships"],

    endpoints: (builder) => ({

        getgetScholarShipUserwithlevel_destiPageApi: builder.query({
            query: () => ({
                url: 'scholarship/getScholarShipUserwithlevel_destiPage',
                method: "GET",
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["scholarships"]
        }),

        getSubjectIndividualScholarShpApi: builder.query({
            query: (id) => (
                console.log("Fetching individual university with ID:", id),
                {
                    url: `studyAbroadCourse/userscholarshipsingle/${id}`,
                    method: 'GET',
                }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["userscholarshipsingle"]
        }),

        getTopScholarshipsFilterApi: builder.query({
            query: (fromComponenet) => (
                console.log(fromComponenet, "from"),
                {
                    url: `scholarship/filterWithScholarships?${fromComponenet}`,
                    method: "GET",
                    
                }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["getfilterWithScholarships"]
        }),


    }),
});

export const {
    useGetgetScholarShipUserwithlevel_destiPageApiQuery,
    useGetSubjectIndividualScholarShpApiQuery,
    useGetTopScholarshipsFilterApiQuery
} = ScholarshipsApiSlice; 